var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3222 2.99656H12.7639L11.6042 1.08638C11.2972 0.574724 10.7855 0.267731 10.2056 0.267731H6.76048C6.1806 0.267731 5.66894 0.574724 5.36195 1.08638L4.2022 2.99656H1.67802C1.20048 2.99656 0.859375 3.37178 0.859375 3.81521C0.859375 4.29276 1.20048 4.63386 1.67802 4.63386H1.95091L2.66723 16.1973C2.70134 17.0842 3.41766 17.7323 4.30453 17.7323H12.6616C13.5484 17.7323 14.2648 17.0842 14.2989 16.1973L15.0493 4.63386H15.3222C15.7656 4.63386 16.1408 4.29276 16.1408 3.81521C16.1408 3.37178 15.7656 2.99656 15.3222 2.99656ZM6.76048 1.90503H10.2056L10.8537 2.99656H6.11238L6.76048 1.90503ZM12.6616 16.095H4.30453L3.58821 4.63386H13.3779L12.6616 16.095Z",
    fill: "#4F46E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.43179408bde89a26f678a2832b2a31ac.svg";
export { ForwardRef as ReactComponent };